import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterActive',
  pure: false
})
export class FilterActivePipe implements PipeTransform {

  transform(value: any, args: string[]): any {
    return value.filter(item => {
        if (args) {
          return true;
        } else {
          if (item.ativo) {
            return true;
          }
        }
      }
    );
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/filter-active.pipe.ts
 **/